import { Form, useSearchParams, useSubmit } from '@remix-run/react'
import { useId } from 'react'
import { useDebounce } from '#app/utils/misc.tsx'
import { Icon } from './ui/icon.tsx'
import { Input } from './ui/input.tsx'

export function SearchBar({
	status,
	autoFocus = false,
	autoSubmit = false,
	path,
	placeholder = 'Realiza tu búsqueda',
}: {
	status: 'idle' | 'pending' | 'success' | 'error'
	autoFocus?: boolean
	autoSubmit?: boolean
	path?: string
	placeholder?: string
}) {
	const id = useId()
	const [searchParams] = useSearchParams()
	const submit = useSubmit()
	/* const isSubmitting = useIsPending({
		formMethod: 'GET',
		formAction: path,
	}) */

	const handleFormChange = useDebounce((form: HTMLFormElement) => {
		submit(form)
	}, 400)

	return (
		<Form
			method="GET"
			action={path}
			className="prose  relative mt-2"
			onChange={e => autoSubmit && handleFormChange(e.currentTarget)}
		>
			<Icon
				name="magnifying-glass"
				className=" absolute left-2.5 top-3 h-4 w-4 text-gray-500 dark:text-gray-400"
			/>
			<Input
				className="w-full appearance-none pl-8"
				type="search"
				placeholder={placeholder}
				name="search"
				id={id}
				defaultValue={searchParams.get('search') ?? ''}
				autoFocus={autoFocus}
			/>
		</Form>
	)
}
